module.exports = __webpack_public_path__ + "static/media/Hero.dbb0eceb.png";